<template>
	<div class="TextareaCounter_wrapper">
		<div class="TextareaCounter">
			<textarea
				class="c_textarea"
				:value="modelValue || value"
				:maxlength="maxlength"
				v-bind="$attrs"
				@input="(event) => emit('update:modelValue', (event.target as HTMLInputElement).value)"
			></textarea>
			<span v-if="maxlength" class="TextareaCounter_counter">
				{{ `${modelValue?.length ?? value?.length ?? 0} / ${maxlength}` }}
			</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';

defineOptions({
	inheritAttrs: false,
});
defineProps<{
	modelValue?: string;
	value?: string;
	maxlength: string;
}>();
const emit = defineEmits(['update:modelValue']);

onMounted(() => {
	const textArea = document.querySelector('.c_textarea') as HTMLElement;
	const textArea_wrapper = document.querySelector('.TextareaCounter_wrapper') as HTMLElement;

	if (textArea && textArea_wrapper) {
		textArea.addEventListener('focus', () => {
			textArea_wrapper.style.borderColor = '#fff';
		});
		textArea.addEventListener('blur', () => {
			textArea_wrapper.style.borderColor = '#818393';
		});
	}
});
</script>

<style scoped lang="scss">
.TextareaCounter_wrapper {
	border: 1px solid var(--color-base-mid);
	border-radius: var(--border-radius-x-small);
	width: 100%;
	padding: 1rem;
	height: 15.2rem;
	.TextareaCounter {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		width: 100%;
		.c_textarea {
			overflow: auto;
			width: 100%;
			border: none;
			padding: 0rem;
			height: 10.2rem;
			&:focus {
				border: none;
				outline: none;
				-webkit-box-shadow: none;
				-moz-box-shadow: none;
				box-shadow: none;
			}
		}
		.TextareaCounter_counter {
			color: var(--color-font-light);
			font-size: var(--font-size-x-small);
			bottom: 1rem;
			width: 100%;
			right: 2rem;
			padding-top: 1rem;
			text-align: end;
		}
	}
}
</style>
